import GalleryHeader from './GalleryHeader';
import './GalleryHeader.scss';

export default GalleryHeader;
